"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.search");
var _perm = require("@/api/perm");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var defaultPerm = {
  id: null,
  name: "",
  type: "目录",
  method: "",
  sort: 1,
  parent: null
};
var _default = exports.default = {
  components: {
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      perm: defaultPerm,
      search: "",
      tableData: [],
      permList: [],
      listLoading: true,
      dialogVisible: false,
      dialogType: "new",
      rule1: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        method: [{
          required: true,
          message: "请输入代号",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _perm.getPermAll)().then(function (response) {
        _this.permList = response.data;
        var data = (0, _utils.genTree)(response.data);
        _this.tableData = data;
        _this.listLoading = false;
      });
    },
    resetFilter: function resetFilter() {
      this.getList();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      var newData = this.permList.filter(function (data) {
        return !_this2.search || data.name.toLowerCase().includes(_this2.search.toLowerCase());
      });
      this.tableData = (0, _utils.genTree)(newData);
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.perm = Object.assign({}, defaultPerm);
      this.dialogType = "new";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs["Form"].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;
      this.perm = Object.assign({}, scope.row); // copy obj
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs["Form"].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this5 = this;
      this.$confirm("确认删除?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "error"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _perm.deletePerm)(scope.row.id);
            case 2:
              _this5.getList();
              _this5.$message({
                type: "success",
                message: "成功删除!"
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirmPerm: function () {
      var _confirmPerm = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(form) {
        var _this6 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this6.dialogType === "edit";
                  if (isEdit) {
                    (0, _perm.updatePerm)(_this6.perm.id, _this6.perm).then(function () {
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: "编辑成功",
                        type: "success"
                      });
                    });
                  } else {
                    (0, _perm.createPerm)(_this6.perm).then(function (res) {
                      // this.perm = res.data
                      // this.tableData.unshift(this.perm)
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: "新增成功",
                        type: "success"
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirmPerm(_x) {
        return _confirmPerm.apply(this, arguments);
      }
      return confirmPerm;
    }()
  }
};